// Header breadcrumb (globaldashboardHead) across pages: a page opened from a record's detail by an in-page action keeps
// that detail's path — S&R → "Universal Quotes": Work Orders | Service & Repair History | ID: 10466 | Universal Quotes;
// UQ → "View Appointment": Work Orders | Universal Quotes | ID: 5835 | Appointment ID: 19337.
// Opened from the side menu or the breadcrumb itself, a page shows its own path as usual.
// Per history entry (history.state.position) sessionStorage keeps: was it a menu navigation, its path and its own crumbs
// (without any inherited prefix, so the trail is one step deep and never grows).
const KEY = "fxCrumbTrail";
let menuNav = false;

const read = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};
const write = (map) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // storage blocked: every page just shows its own path
  }
};
const position = () => window.history.state?.position;

// side menu / breadcrumb clicks: the next navigation is a menu one
export function markMenuNav() {
  menuNav = true;
}

// router.afterEach: tag the entry we landed on
// Browser back / forward lands on an entry we already tagged (vue-router's history.state.forward is set then):
// keep its tag, or a list opened from the menu would inherit the previous detail's trail after Back.
export function recordCrumbNav() {
  const pos = position();
  if (typeof pos === "number") {
    const map = read();
    const revisit = map[pos] && window.history.state?.forward;
    if (!revisit) {
      map[pos] = { menu: menuNav };
      write(map);
    }
  }
  menuNav = false;
}

// the header saves the page's own path (not what it inherited), so the next page can extend it by one step
export function saveCrumbs(crumbs) {
  const pos = position();
  if (typeof pos !== "number") return;
  const map = read();
  map[pos] = { ...map[pos], path: window.location.pathname + window.location.search, crumbs };
  write(map);
}

// crumbs of the detail page this one was opened from (last crumb "ID: …" turned into a link), or null
export function detailTrail() {
  const pos = position();
  const map = read();
  if (typeof pos !== "number" || map[pos]?.menu) return null;
  const prev = map[pos - 1];
  const last = prev?.crumbs?.[prev.crumbs.length - 1];
  if (!last || !/^ID: /.test(last.label) || window.history.state?.back !== prev.path) return null;
  return [...prev.crumbs.slice(0, -1), { ...last, to: prev.path }];
}
